import { PhysicsConfig } from '../types';

/**
 * Physics configuration for momentum-based video playback
 * 
 * These values control the "feel" of the tape deck interaction.
 * Adjust these to fine-tune the momentum and responsiveness.
 */
export const PHYSICS_CONFIG: PhysicsConfig = {
    /**
     * Lerp factor for smooth interpolation
     * - Lower values (0.05-0.1) = more smoothing, slower response
     * - Higher values (0.2-0.3) = less smoothing, snappier response
     * - Recommended: 0.15 for a balanced, premium feel
     */
    lerpFactor: 0.15,

    /**
     * Maximum velocity in frames per tick
     * - At 60fps ticker, 0.5 = ~30 frames per second max speed
     * - Adjust based on your total frame count and desired max speed
     * - Recommended: 0.5 for smooth, controllable scrubbing
     */
    maxVelocity: 0.5,

    /**
     * Acceleration rate when key is held
     * - How quickly velocity increases when pressing arrow keys
     * - Higher = faster ramp-up to max speed
     * - Recommended: 0.08 for gradual, natural acceleration
     */
    acceleration: 0.08,

    /**
     * Friction/deceleration rate when key is released
     * - How quickly velocity decreases when no input
     * - Higher = faster stop, less drift
     * - Lower = more drift, "heavier" feel
     * - Recommended: 0.92 for satisfying momentum decay
     */
    friction: 0.92,
};

/**
 * Frame bounds configuration
 */
export const FRAME_CONFIG = {
    /**
     * Whether to loop playback when reaching the end
     */
    loop: true,

    /**
     * Minimum frame index (0-based)
     */
    minFrame: 0,
};
